
import React from 'react'
import Portal from './Portal'
import Box from './Box'

// TODO: animate close

/**
 * Overlay component.
 */

export default function Overlay({ children, ...props }) {
  return <Portal>
    <Box className="Overlay" {...props}>
      {children}
    </Box>
  </Portal>
}